import React from 'react';
import {BooleanInput, Edit, SimpleForm, TextInput} from 'react-admin';

const HatedFoodEdit = (props) => {
    return (
        <Edit {...props}>
            <SimpleForm>
                <BooleanInput source="deleted" />
                <TextInput source="name" />
            </SimpleForm>
        </Edit>
    );
};

export default HatedFoodEdit;